import React from "react"
import { createPerformanceTableTool } from "@/editor/createPerformanceTableTool"

export const SmallPerformanceByVintageTableTool = createPerformanceTableTool({
  type: "small_performance_by_vintage_table",
  headerText: "Performance by Vintage",
  columnHeader: "Vintage",
  dataProperty: "vintage",
  toolboxTitle: "Vintage Performance Table",
})
